import { createContext } from 'react';
/** Only invitation editor/preview roots provide a mapping; other scenarios are unchanged. */
export const ScoreNumberingContext = createContext<Record<string, string>>({});
